import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createChargingService } from '../../api/charging-service.ts';
import { CreateChargingServiceRequest } from '../../api/requests/charging-service-request.ts';

export default function useCreateChargingService(): UseMutationResult<
  Awaited<ReturnType<typeof createChargingService>>,
  Error,
  CreateChargingServiceRequest
> {
  return useMutation({
    mutationFn: createChargingService,
  });
}
